<template>
  <div
    class="*:first:rounded-t-extra-large! *:last:rounded-b-extra-large! *:rounded-extra-small flex flex-col gap-0.5"
  >
    <div
      v-if="showBlindspots"
      class="bg-surface-container-low flex w-full flex-row justify-end px-4 py-2"
    >
      <BaseConnectedButtonGroup
        v-model="mainFilter"
        full-width
        class="grow"
        size="XS"
        color="outlined"
        :items="[
          { label: 'Alle', value: 'all', icon: 'list', onlyIcon: true, shrink: true },
          { label: 'Stärken', value: 'strength' },
          { label: 'Potentiale', value: 'potential' },
          { label: 'Blinde Flecken', value: 'blindspot' },
        ]"
      />
    </div>
    <div
      class="bg-surface-container-low flex p-4"
      :class="[allQuestions.length === 0 && 'rounded-b-extra-large!']"
    >
      <PerspectiveLegend :all-perspectives="topicPerspectives" />
    </div>
    <template v-if="allQuestions.length">
      <QuestionItem
        v-for="(question, index) in allQuestions"
        :key="question.question.id + mainFilter"
        :content="question.question.content"
        :perspectives="question.perspectives"
        :topic-perspectives="topicPerspectives"
        :expanded="expandedQuestionId == question.question.id"
        :scale="scale"
        :labels="question.labels"
        :subject="subject"
        :index="index"
        @click="emits('questionClicked', question.question.id)"
      />
    </template>
    <EmptyQuestions v-else>
      <BaseTextButton
        v-if="showBlindspots"
        size="XS"
        color="text"
        class="text-on-surface-variant!"
        @click="showAll"
      >
        Alle Fragen anzeigen</BaseTextButton
      >
    </EmptyQuestions>
  </div>
</template>
<script lang="ts" setup>
  import { toRef } from 'vue'

  import EmptyQuestions from './EmptyQuestions.vue'
  import QuestionItem from './QuestionItem.vue'
  import type { Scale } from '../../../models/scale.ts'
  import BaseConnectedButtonGroup from '../../base/button/BaseConnectedButtonGroup.vue'
  import type { QuestionAnalysis } from '@/core/models/surveys-analytics'
  import { useQuestionAnalysisNew } from '@/core/composables/use-question-analysis-new'
  import BaseTextButton from '../../base/button/text-button/BaseTextButton.vue'
  import type { MemberOrUser } from '@/core/models/member/member-or-user'
  import type { Perspective } from '@/core/models/perspective'
  import PerspectiveLegend from './PerspectiveLegend.vue'

  interface Props {
    questions: ReadonlyArray<QuestionAnalysis>
    topicPerspectives: ReadonlyArray<Perspective>
    scale: Scale
    expandedQuestionId: string | null
    subject: MemberOrUser
    showBlindspots: boolean
  }

  const props = defineProps<Props>()

  const emits = defineEmits<{
    (e: 'questionClicked', questionId: string): void
  }>()

  const showAll = () => {
    mainFilter.value = 'all'
  }

  const { allQuestions, mainFilter } = useQuestionAnalysisNew(
    toRef(props, 'questions'),
    props.showBlindspots,
  )
</script>
